import React from 'react';
import {
  Wrench,
  Zap,
  Hammer,
  Layers,
  Paintbrush,
  Armchair,
  Grid,
  Flame,
  Fan,
  Cpu,
  Tv,
  HelpCircle,
  LucideIcon,
  Sparkles,
  Home,
  Square,
  Key,
  Shield,
  Sun,
  Smartphone,
  Car,
  Trees,
  Truck,
  ThermometerSnowflake,
} from 'lucide-react';

interface CategoryIconProps {
  slug: string;
  className?: string;
}

export const CategoryIcon: React.FC<CategoryIconProps> = ({ slug, className = 'w-5 h-5' }) => {
  const iconMap: Record<string, LucideIcon> = {
    plumber: Wrench,
    electrician: Zap,
    carpenter: Hammer,
    bricklayer: Layers,
    painter: Paintbrush,
    'furniture-maker': Armchair,
    tiler: Grid,
    welder: Flame,
    'ac-technician': Fan,
    'generator-technician': Cpu,
    'refrigeration-technician': ThermometerSnowflake,
    cleaner: Sparkles,
    'pop-ceiling-installer': Layers,
    roofer: Home,
    'aluminum-glass-installer': Square,
    locksmith: Key,
    'cctv-security-installer': Shield,
    'solar-technician': Sun,
    'appliance-repair': Tv,
    'phone-computer-technician': Smartphone,
    'auto-mechanic': Car,
    'landscaper-gardener': Trees,
    'moving-relocation-services': Truck,
    other: HelpCircle,
  };

  const IconComponent = iconMap[slug] || Wrench;
  return <IconComponent className={className} />;
};
